import React, { Fragment, memo } from 'react'
import { Typography } from '@mui/material'
import { colors } from 'src/theme'

interface Props {
  prefix: string
  contractorName: string
}

const ResendConfirmTextComponent = ({ prefix, contractorName }: Props) => {
  return (
    <Fragment>
      {prefix}{' '}
      <Typography component="span" variant="h6" color={colors.BASICS_BLACK}>
        {contractorName}
      </Typography>
      ?
    </Fragment>
  )
}

export const ResendConfirmText = memo(ResendConfirmTextComponent)
